export interface SendGuardErrorDetails {
  isGuardError: boolean;
  code?: "UNRENDERED_PLACEHOLDER" | "SEED_TEMPLATE_FAILED";
  message: string;
  tokens?: string[];
  seedKey?: string;
  stepId?: string;
  draftId?: string;
  draftUrl?: string;
}

export function parseSendGuardError(error: any): SendGuardErrorDetails {
  const raw = String(error?.message || "");
  const m = raw.match(/^(\d{3}):\s*([\s\S]+)$/);
  if (m && m[1] === "422") {
    try {
      const parsed = JSON.parse(m[2]);
      if (parsed && typeof parsed === "object" && parsed.code) {
        return {
          isGuardError: true,
          code: parsed.code,
          message: typeof parsed.message === "string" ? parsed.message : raw,
          tokens: Array.isArray(parsed.tokens) ? parsed.tokens : undefined,
          seedKey: typeof parsed.seedKey === "string" ? parsed.seedKey : undefined,
          stepId: typeof parsed.stepId === "string" ? parsed.stepId : undefined,
          draftId: typeof parsed.draftId === "string" ? parsed.draftId : undefined,
          draftUrl: typeof parsed.draftUrl === "string" ? parsed.draftUrl : undefined,
        };
      }
    } catch {
      /* not JSON — fall through */
    }
  }
  return { isGuardError: false, message: raw };
}

export function describeSendError(
  error: any,
  fallback: string = "Failed to send.",
): { title: string; description: string; details: SendGuardErrorDetails } {
  const details = parseSendGuardError(error);
  if (details.isGuardError && details.code === "UNRENDERED_PLACEHOLDER" && details.tokens?.length) {
    const tokenList = details.tokens.join(", ");
    const draftNote = details.draftUrl
      ? " Your message was saved to Drafts — open it there to fix and resend."
      : " Edit your message and click Send again.";
    return {
      title: "Message saved to drafts",
      description: `Your template has ${tokenList} which couldn't be filled in automatically.${draftNote}`,
      details,
    };
  }
  if (details.isGuardError && details.code === "SEED_TEMPLATE_FAILED") {
    return {
      title: "Send blocked",
      description:
        details.message ||
        "This automation template is currently flagged as failing. Update the template before sending again.",
      details,
    };
  }
  return {
    title: details.isGuardError ? "Send blocked" : "Error",
    description: details.message || fallback,
    details,
  };
}
